// extracted by css-extract-rspack-plugin
export default {"moreFiltersButton":"_93d44edf"};